export default __webpack_public_path__ + "static/media/puzzle_4.4b0b8b4d.png";